import{Model} from 'ords/dist/model/model';

export class QuestionnaireQuestion extends Model{

}

export const QuestionnaireQuestionModelConfig = {
    name: 'questionnaire_question',
    model: QuestionnaireQuestion,
    relations: []
}
